const TESTIMONIALS = [
  {
    text: 'My stay at Monalisa was spectacular. From the moment I entered, I was struck by the elegance and welcoming atmosphere. The staff was always friendly and helpful, making our visit even more special. We will definitely be back soon.',
    rating: 5,
    name: 'Hal Finney',
    jobPosition: 'Marketing Manager',
  },
  {
    text: 'The Monalisa Resort is simply incredible. The facilities are top-notch, and the views from my room were breathtaking. The customer service exceeded all my expectations. A perfect place to relax and unwind.',
    rating: 5,
    name: 'Gavin Andresen',
    jobPosition: 'Financial Consultant',
  },
  {
    text: 'I have never experienced such a level of luxury and comfort as at Monalisa. The attention to detail in every corner of the hotel was astonishing. The restaurant offered an exquisite variety of dishes, all delicious. Highly recommended!',
    rating: 5,
    name: 'Martti Malmi',
    jobPosition: 'Real Estate Agent',
  },
  {
    text: 'I had a wonderful weekend at the Monalisa Resort. The location is perfect, and the quality of service is unmatched. The spa was a rejuvenating experience that left me completely relaxed. I can’t wait to return!',
    rating: 4,
    name: 'Jeff Garzik',
    jobPosition: 'Event Planner',
  },
  {
    text: 'From the moment we arrived, we were treated like royalty. The staff is exceptionally attentive and kind. The rooms are spacious and comfortable, and the decor is modern and sophisticated. An unforgettable experience.',
    rating: 5,
    name: 'Laszlo Hanyecz',
    jobPosition: 'Software Engineer',
  },
  {
    text: 'Monalisa - Hotel & Resort is a true paradise. The leisure areas and the surrounding landscape create a serene and peaceful environment. The breakfast buffet had a great variety and everything was delicious. We will definitely be back.',
    rating: 4,
    name: 'Nick Szabo',
    jobPosition: 'Architect',
  },
  {
    text: 'This is the best hotel I have ever stayed in. Everything, from check-in to check-out, was impeccable. The gardens are beautiful and the staff always made sure we had everything we needed. Highly recommended.',
    rating: 5,
    name: 'Adam Back',
    jobPosition: 'Business Consultant',
  },
  {
    text: 'Monalisa offers a perfect combination of luxury and comfort. The views from the pool are stunning, and the quality of service is outstanding. An ideal place for a family vacation or a romantic getaway.',
    rating: 5,
    name: 'Charlie Lee',
    jobPosition: 'Graphic Designer',
  },
];

export { TESTIMONIALS };
